import SuccessErrorModalBodyTemplate from "./SuccessErrorModalBodyTemplate";

export default SuccessErrorModalBodyTemplate;
